import React, { useContext, useEffect, useRef, useState } from 'react';
import './PurchaseInvoice.css';
import { useParams } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { formatedDate } from '../../Helper/constent';

const StockPrint = () => {
    const { store_id, keyword, limit, order, category_id } = useParams();
    const parsedKeyword = keyword === '-' ? '' : keyword;
    const parsedCategoryId = category_id === '-' ? null : category_id;
    const toast = useRef(null);
    const [dataLoading, setDataLoading] = useState(true);
    const [invoiceData, setInvoiceData] = useState([]);
    const [products, setProducts] = useState([]);
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const headers = apiHeadersJson;

    const handlePrint = () => {
        window.print();
    };

    const GetList = async () => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/ProductList`, { params: { store_id, keyword: parsedKeyword, limit, order, product_for_order: [0, 1], category_id: parsedCategoryId, isprint: 1 }, headers });
            const { success, data, info, message } = response.data;

            if (success) {
                setInvoiceData(info);
                setProducts(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
        } finally {
            setDataLoading(false);
        }
    };

    useEffect(() => {
        GetList();
    }, []);

    if (dataLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
            </div>

        )
    }
    const purchaseDetails = invoiceData.length > 0 ? invoiceData[0] : {};

    const groupedProducts = products.reduce((acc, product) => {
        if (!acc[product.category_name]) {
            acc[product.category_name] = [];
        }
        acc[product.category_name].push(product);
        return acc;
    }, {});

    return (
        <>
            <div className="purchase-invoice-container">
                <div className="d-flex justify-content-center align-items-center">
                    <img src={purchaseDetails?.store_logo_url} alt="Logo" width={120} />
                </div>
                <p className='text-center my-2'>{purchaseDetails?.store_address}</p>
                <div className="purchase-invoice-details">
                    <p><span>Date:</span> <br /> {formatedDate(new Date())}</p>
                    <p><span>Print by:</span> <br /> {purchaseDetails?.user_name}</p>
                </div>

                {/* Product List by Category */}
                <div className="purchase-product-list">
                    <table>
                        <thead>
                            <tr>
                                <th className='text-start'>Items</th>
                                <th className='text-end'>Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedProducts).map(([category, items]) => (
                                <React.Fragment key={category}>
                                    {/* Category Row */}
                                    <tr className="purchase-category-row">
                                        <td colSpan="4" className="purchase-category-header">
                                            <span>{category}</span>
                                        </td>
                                    </tr>
                                    {/* Product Rows */}
                                    {items.map((product, index) => (
                                        <tr key={index}>
                                            <td className='text-start'>{product.product_name}</td>
                                            <td className='text-end'>{product.total_remaining}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="section-divider"></div>
            </div>
            <button onClick={handlePrint} className="purchase-print-button">Print</button>
        </>
    );

};

export default StockPrint;
